/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ReferrerAlertTypeResource } from './';
import {
    ReferrerAlertTypeResourceFromJSON,
    ReferrerAlertTypeResourceFromJSONTyped,
    ReferrerAlertTypeResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReferrerAlertsResource
 */
export interface ReferrerAlertsResource {
    /**
     * referrer alerts list
     * @type {Array<ReferrerAlertTypeResource>}
     * @memberof ReferrerAlertsResource
     */
    alerts?: Array<ReferrerAlertTypeResource>;
}

/**
 * Check if a given object implements the ReferrerAlertsResource interface.
 */
export function instanceOfReferrerAlertsResource(value: object): value is ReferrerAlertsResource {
    return true;
}

export function ReferrerAlertsResourceFromJSON(json: any): ReferrerAlertsResource {
    return ReferrerAlertsResourceFromJSONTyped(json, false);
}

export function ReferrerAlertsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferrerAlertsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'alerts': json['alerts'] == null ? undefined : ((json['alerts'] as Array<any>).map(ReferrerAlertTypeResourceFromJSON)),
    };
}

export function ReferrerAlertsResourceToJSON(value?: ReferrerAlertsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'alerts': value['alerts'] == null ? undefined : ((value['alerts'] as Array<any>).map((v) => ReferrerAlertTypeResourceToJSON(v))),
    };
}

